import type { DeliveryMethod } from '@libs/common-types';

/**
 * True when the delivery method supports at least one of one-time or autoship purchase
 * (replaces legacy `isEnabled`).
 */
export function isPurchaseOptionAvailable(
    method: DeliveryMethod | Pick<DeliveryMethod, 'availablePurchaseOptions'> | undefined
): boolean {
    const opts = method?.availablePurchaseOptions;
    if (!opts) return false;
    return opts.oneTime || opts.autoship;
}
